import React, { FC } from 'react';
import styles from './PlatformShowcase.module.scss';
import trustHubScreen from '../../../../assets/images/screenshot-trusthub.png';
import ReadMore from '../../../primitives/read-more/ReadMore';
import PlatformLabel from '../../../primitives/platform-label/PlatformLabel';
import classNames from 'classnames';
import { CONTACT_EMAIL, PageSectionKeys } from '../../../../utils/constants';

const TrustHubPortal: FC = () => {
	return (
		<section className={styles.platform}>
			<div className={styles.container}>
				<div
					id={PageSectionKeys.trustHubPortal}
					className={classNames(styles.panel, styles.trustHub)}
				>
					<div className={styles.info}>
						<h3>TrustHUB Portal</h3>

						<p>
							A secure external portal for sharing compliance documentation and
							security posture with clients and third parties — controlled access,
							approval-based, and always current.
						</p>

						<ReadMore text="Learn More" href={`mailto:${CONTACT_EMAIL}`} />
					</div>

					<div className={styles.image}>
						<PlatformLabel
							className={styles['label-trustHub']}
							text="TrustHUB Portal"
							type="trustHub"
						/>

						<img
							className={styles['rounded-img']}
							src={trustHubScreen}
							alt="TrustHUB"
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TrustHubPortal;